import styled from "styled-components";
import { Switch } from "antd";

export const ModalBody = styled.div`
  font-family: "Inter", sans-serif;
`;

export const ModalTitle = styled.h2`
  margin: 0;
  color: #000000;
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
`;

export const ModalSubtitle = styled.p`
  margin: 4px 0 28px;
  color: #666666;
  font-size: 13px;
  font-weight: 400;
  line-height: 16px;
`;

export const Section = styled.section`
  & + & {
    margin-top: 28px;
  }
`;

export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 8px;
`;

export const SectionTitle = styled.h3`
  margin: 0;
  color: #1a1a1a;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
`;

export const Columns = styled.div`
  display: flex;
  align-items: center;
`;

export const ColumnLabel = styled.span`
  width: 84px;
  text-align: center;
  color: #666666;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
`;

export const PreferenceRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 12px 0;
  border-bottom: 1px solid #f0f0f0;
`;

export const RowText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
`;

export const RowLabel = styled.span`
  color: #1a1a1a;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
`;

export const RowDescription = styled.span`
  max-width: 260px;
  color: #666666;
  font-size: 11px;
  font-weight: 400;
  line-height: 14px;
`;

export const SwitchCell = styled.div`
  display: flex;
  justify-content: center;
  width: 84px;
`;

export const PreferenceSwitch = styled(Switch)`
  &.ant-switch-checked {
    background: #ff4a01;
  }

  &.ant-switch-checked:hover:not(.ant-switch-disabled) {
    background: #e64300;
  }
`;
